import { IGapWarningConfig } from './IGapWarningConfig';

export class GapWarningInfo implements IGapWarningConfig {
    warningType: string;

    dateFrom: string;

    dateTo: string;

    constructor(warningType: string, dateFrom: string, dateTo: string) {
      this.warningType = warningType;
      this.dateFrom = dateFrom;
      this.dateTo = dateTo;
    }
}

export default GapWarningInfo;
